import { makeStyles } from '@material-ui/core/styles';
import { colors } from 'theme/color-palette';
import { cssVariables } from 'theme/theme';
const { TOGGLE_ACTIVE, PURPLE, FONT_COLOR, WHITE, DISABLED, BLUE_ACTIVE, INACTIVE } = colors;

const renderDaysStyle = makeStyles(() => ({
	dayBg: {
		backgroundColor: TOGGLE_ACTIVE
	},
	dayBgBorderStart: {
		borderTopLeftRadius: 25,
		borderBottomLeftRadius: 25
	},
	dayBgBorderEnd: {
		borderTopRightRadius: 25,
		borderBottomRightRadius: 25
	},
	block: {
		width: cssVariables.container.width / 10,
		height: cssVariables.container.width / 10,
		color: FONT_COLOR,
		display: 'flex',
		justifyContent: 'center',
		alignItems: 'center',
		backgroundColor: WHITE,
		fontSize: cssVariables.day.fontSize,
		fontWeight: 'bold',
		padding: 2,
		margin: 0.5
		/* font-family: "bogle-regular"; */
	},
	range: {
		color: WHITE,
		backgroundColor: PURPLE,
		borderRadius: 25
	},
	disabled: {
		color: DISABLED
	},
	daySelected: {
		backgroundColor: TOGGLE_ACTIVE
	},
	nextDays: {
		color: INACTIVE
	},
	prevDays: {
		color: INACTIVE
	},
	dayTransparent: {
		backgroundColor: 'transparent'
	},
	today: {
		backgroundColor: BLUE_ACTIVE,
		borderRadius: 50,
		color: WHITE
	},
	dftCursor: {
		cursor: 'default'
	},
	pointerCursor: {
		cursor: 'pointer'
	}
}));

export default renderDaysStyle;
